import { AbstractWinDisplayProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractWinDisplayProperties";
/**
 * GameWinDisplayProperties.ts
 */
export class GameWinDisplayProperties extends AbstractWinDisplayProperties {
    equals(other) {
        return super.equals(other) &&
            this.gameOverSpineProperties.equals(other.gameOverSpineProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
    }
}
//# sourceMappingURL=GameWinDisplayProperties.js.map